import { render, staticRenderFns } from "./EditReportDialog.vue?vue&type=template&id=0b7ebe39&scoped=true"
import script from "./EditReportDialog.vue?vue&type=script&lang=js"
export * from "./EditReportDialog.vue?vue&type=script&lang=js"
import style0 from "./EditReportDialog.vue?vue&type=style&index=0&id=0b7ebe39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ebe39",
  null
  
)

export default component.exports